import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { IMAGES } from './data/landing';
const META_PIXEL_ID = '2202174087193139';
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;700;800&family=Cinzel:wght@600&display=swap';
function addLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([key, value]) => {
    link.setAttribute(key, value);
  });
  document.head.appendChild(link);
  return link;
}
export function App() {
  // Critical path: warm up the CDN and fetch the LCP image as early as possible.
  useEffect(() => {
    addLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    addLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    addLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    addLink({
      rel: 'preload',
      as: 'image',
      href: IMAGES.heroMockup,
      fetchpriority: 'high'
    });

    // Fonts load without blocking the first render, then swap in.
    const fonts = addLink({
      rel: 'stylesheet',
      href: FONTS_HREF,
      media: 'print'
    });
    const activate = () => {
      fonts.media = 'all';
    };
    fonts.addEventListener('load', activate);
    return () => fonts.removeEventListener('load', activate);
  }, []);

  // Meta Pixel is deferred so it never competes with the initial render.
  useEffect(() => {
    let cancelled = false;
    let loaded = false;
    const loadPixel = () => {
      if (cancelled || loaded) return;
      loaded = true;
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];
        t=b.createElement(e);t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}
        (window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${META_PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };

    // Schedule it in idle time so it never lands inside a long main-thread task.
    const schedule = () => {
      const idle = (window as any).requestIdleCallback;
      if (typeof idle === 'function') {
        idle(loadPixel, {
          timeout: 2000
        });
      } else {
        loadPixel();
      }
    };
    const timer = window.setTimeout(schedule, 4000);
    const onInteraction = () => {
      window.clearTimeout(timer);
      schedule();
    };
    window.addEventListener('pointerdown', onInteraction, {
      once: true
    });
    window.addEventListener('scroll', onInteraction, {
      once: true,
      passive: true
    });
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      window.removeEventListener('pointerdown', onInteraction);
      window.removeEventListener('scroll', onInteraction);
    };
  }, []);
  return <LandingPage data-id="element-0" data-mp="1w3vm812xzb3r" />;
}